import React from 'react';
import { FaPencilRuler, FaLightbulb, FaLeaf } from 'react-icons/fa';

const Design = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-6 text-center text-purple-600">Servicios de Diseño</h1>

      <div className="grid md:grid-cols-2 gap-8 items-center mb-12">
        <div>
          <h2 className="text-2xl font-semibold mb-4">Diseño Innovador y Funcional</h2>
          <p className="text-gray-700 mb-4">
            Nuestro equipo de diseñadores combina creatividad y funcionalidad para crear espacios 
            que no solo son hermosos, sino también prácticos y acogedores. Trabajamos estrechamente 
            con nuestros clientes para entender sus necesidades y preferencias, garantizando un 
            resultado que supere sus expectativas.
          </p>
          <ul className="list-disc list-inside text-gray-700">
            <li>Diseño de interiores residenciales y comerciales</li>
            <li>Planificación espacial y optimización de layouts</li>
            <li>Selección de materiales y paletas de colores</li>
            <li>Diseño de iluminación y mobiliario personalizado</li>
          </ul>
        </div>
        <div className="flex justify-center">
          <FaPencilRuler className="text-purple-500 w-64 h-64" />
        </div>
      </div>

      <div className="bg-gray-100 p-8 rounded-lg shadow-md">
        <h3 className="text-xl font-semibold mb-4">Nuestro Enfoque de Diseño</h3>
        <div className="grid md:grid-cols-3 gap-6">
          <div className="text-center">
            <FaLightbulb className="mx-auto text-purple-500 w-12 h-12 mb-2" />
            <h4 className="font-semibold mb-2">Innovación</h4>
            <p className="text-sm text-gray-600">Soluciones creativas y únicas</p>
          </div>
          <div className="text-center">
            <FaPencilRuler className="mx-auto text-purple-500 w-12 h-12 mb-2" />
            <h4 className="font-semibold mb-2">Precisión</h4>
            <p className="text-sm text-gray-600">Atención meticulosa a los detalles</p>
          </div>
          <div className="text-center">
            <FaLeaf className="mx-auto text-purple-500 w-12 h-12 mb-2" />
            <h4 className="font-semibold mb-2">Sostenibilidad</h4>
            <p className="text-sm text-gray-600">Diseños eco-amigables y eficientes</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Design;